import { LogEntry } from '@monorepo/shared/componentsV2/logs/types';
import { useLogFieldOptionsForUpload } from '@monorepo/shared/hooks/logs/useLogFieldOptionsForUpload';
import { useLogEntryFields } from '@monorepo/shared/hooks/logs/useLogFields';
import { useLogInfo } from '@monorepo/shared/hooks/logs/useLogInfo';
import { useCallback } from 'react';
import {
  convertLogEntriesFormFieldValuesToLogEntryResponses,
  LogEntriesFormValues,
} from '../conversionHelpers';

export function useHandleMapLogEntryFormValuesIntoLogEntries({
  organizationId,
  logId,
  projectId,
  isOpen,
  logEntries,
}: {
  organizationId: string;
  logId: string;
  projectId: string;
  isOpen: boolean;
  logEntries: LogEntry[];
}) {
  const { logFields } = useLogEntryFields({
    organizationId,
    logId,
  });
  const { logInfo } = useLogInfo({
    config: { enabled: isOpen },
    logId,
    organizationId,
  });
  const { logFieldOptionsForUpload } = useLogFieldOptionsForUpload({
    config: { enabled: isOpen },
    logInfo,
    organizationId,
    projectId,
  });

  const handleMapLogEntryFormValuesIntoLogEntries = useCallback(
    (formValues: Partial<LogEntriesFormValues>) => {
      if (!logFields || !logFieldOptionsForUpload)
        throw new Error('Failed to load log field options.');
      const logEntriesFromFormValues =
        convertLogEntriesFormFieldValuesToLogEntryResponses({
          logId,
          projectId,
          logEntries,
          formValues,
          logFields,
          logFieldOptions: logFieldOptionsForUpload,
        });
      const updatedLogEntries = logEntries.map(
        (entry) => logEntriesFromFormValues[entry.id] ?? entry,
      );
      return updatedLogEntries;
    },
    [logEntries, logFieldOptionsForUpload, logFields, logId, projectId],
  );

  return handleMapLogEntryFormValuesIntoLogEntries;
}
